// The rule the platform already follows is that user work-product lives server-side — caught three
// times; these are the caches and drafts that legitimately don't, plus Haney which is still
// awaiting its server home.
import { purgeFieldRecSets } from "./fertSets";
import { purgeDismissals } from "./flagDismissals";

/* * Keys shaped `prefix:<field_id>` — one entry per field. */
const PER_FIELD_KEYS = [
  "sm_haney", // stores/haneyStore.ts — user-entered Haney results
  "sm_target_designs", // stores/targetSamplingStore.ts — saved sampling designs
] as const;

/* * Keys holding a `{ [field_id]: value }` map — one entry for the whole app. */
const FIELD_MAP_KEYS = [
  "sm_soilmap_last_job", // features/map-soil-props/MapSoilPropsOptions.tsx — last dispatched mapping job
] as const;

/* * Forget everything this browser holds for a field. Safe to call for a field that has none. */
export function purgeFieldLocalData(fieldId: string): void {
  purgeFieldRecSets(fieldId);
  purgeDismissals(fieldId);
  for (const prefix of PER_FIELD_KEYS) {
    try {
      localStorage.removeItem(`${prefix}:${fieldId}`);
    } catch {
      /* storage unavailable — nothing to purge */
    }
  }
  for (const key of FIELD_MAP_KEYS) {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) continue;
      const map = JSON.parse(raw) as Record<string, unknown>;
      if (!(fieldId in map)) continue;
      delete map[fieldId];
      localStorage.setItem(key, JSON.stringify(map));
    } catch {
      /* malformed or unavailable — leaving it is better than clearing someone else's entries */
    }
  }
}
